import React from "react";
import { useFacility } from "@/context/FacilityContext";
import { PageHeader } from "@/components/common/PageHeader";
import { CrudTable } from "@/components/common/CrudTable";

export default function Services() {
  const { activeId, has, activeFacility } = useFacility();
  return (
    <div data-testid="services-page">
      <PageHeader title="Services" subtitle={activeFacility ? `Service catalogue offered at ${activeFacility.name}.` : "Select a facility to manage services."} />
      <CrudTable
        endpoint="services" facilityId={activeId} entityName="Service" canEdit={has("service:create")}
        testId="services-crud"
        columns={[{ key: "name", label: "Service" }, { key: "category", label: "Category" }, { key: "price", label: "Price (₹)", render: (r) => (r.price ?? 0).toLocaleString() }, { key: "duration_minutes", label: "Duration", render: (r) => `${r.duration_minutes || 0} min` }]}
        fields={[{ key: "name", label: "Service name", full: true }, { key: "code", label: "Code" }, { key: "category", label: "Category" }, { key: "price", label: "Price (₹)", type: "number" }, { key: "duration_minutes", label: "Duration (min)", type: "number" }]}
      />
    </div>
  );
}
